import { render } from "./ReceiptContent.vue?vue&type=template&id=151f2488"
import script from "./ReceiptContent.vue?vue&type=script&lang=js"
export * from "./ReceiptContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__